// extracted by mini-css-extract-plugin
module.exports = {"postCard":"PostCard_postCard__FN3m9 card_card__oDiig","featuredPost":"PostCard_featuredPost__Fv9mt","featuredThumbnail":"PostCard_featuredThumbnail__gI4_d"};